export default function Marquee({ items, className = "", dark = false }) {
  const strip = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center whitespace-nowrap font-display text-2xl font-black uppercase tracking-wide md:text-3xl">
          {it}
          <span className={`mx-8 inline-block h-2.5 w-2.5 rotate-45 ${dark ? "bg-black" : "bg-volt"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden ${className}`}>
      <div className="flex w-max animate-marquee">
        {strip(false)}
        {strip(true)}
      </div>
    </div>
  );
}
